import * as yup from 'yup';
import { TemplateForm } from '../types/index';

const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;
const displayNameEmailRegex = /^[^<>";!#$%&()*+,/:;=?@\[\]]+ <[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}>$/;

const validateEmail = (value: string) => {
  return emailRegex.test(value) || displayNameEmailRegex.test(value);
};

export type ValidationResult = string | undefined;
export type ValidationFn = (value: any) => ValidationResult;
export type ValidationSchema = {
    [K in keyof Partial<TemplateForm>]: ValidationFn;
};

// Base schema that is common across all use cases
const baseSchema = yup.object({
  from: yup.string()
    .required('From field is required')
    .test('email', 'Please enter either an email address or use format: "Display Name <email@domain>"', validateEmail),
  subject: yup.string()
    .required('Subject is required'),
  body: yup.string()
    .required('Body is required'),
});

// Additional validations for rewrite functionality
const rewriteValidations = {
  allowedDomains: yup.array()
    .min(1, 'At least one domain must be selected')
    .required('At least one domain must be selected'),
  senderBias: yup.string()
    .required('Please select a sender bias'),
  contentBiases: yup.array()
    .min(1, 'Please select at least one content bias')
    .required('Please select at least one content bias'),
};

// Predefined schemas for different use cases
export const analyzeSchema = baseSchema;

export const rewriteSchema = baseSchema.shape(rewriteValidations); 